import { ReactElement } from 'react';
import { MdCalendarToday } from 'react-icons/md';

export interface FlightingRow {
  channel: string;
  prevFlighting: string;
  newFlighting: string;
}

interface FlightingChangesTableProps {
  rows: FlightingRow[];
}

export const FlightingChangesTable = ({ rows }: FlightingChangesTableProps): ReactElement => (
  <div className='flighting-changes-section'>
    <div className='flighting-changes-header'>
      <MdCalendarToday />
      <span>Flighting Changes</span>
    </div>
    <table className='flighting-changes-table'>
      <thead>
        <tr>
          <th>Channel</th>
          <th>Previous Flighting</th>
          <th>New Flighting</th>
          <th>Change</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i}>
            <td className='flighting-channel'>{row.channel}</td>
            <td>{row.prevFlighting}</td>
            <td className='flighting-new'>{row.newFlighting}</td>
            <td>
              {row.prevFlighting} → {row.newFlighting}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
